import {Component, OnInit} from '@angular/core';
import {AccessService} from '../services/access.service';

@Component({
  selector: 'app-application-form-oia',
  templateUrl: './application-form-oia.component.html',
  styleUrls: ['./application-form-oia.component.css']
})
export class ApplicationFormOiaComponent implements OnInit {

    constructor(private accessService: AccessService) { }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

    ngOnInit() {
    }
}
